import * as types from './types';

const action = type => ({ type });

export const open = action(types.LIGHTBOX_OPEN);
export const close = action(types.LIGHTBOX_CLOSE);
export const prev = action(types.LIGHTBOX_PREVIOUS_IMAGE);
export const next = action(types.LIGHTBOX_NEXT_IMAGE);



// WEBPACK FOOTER //
// ./src/lightbox/actions.js